module.exports = __webpack_public_path__ + "img/3c008b5.jpg";